import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Col, Form, Row } from 'react-bootstrap';
import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';
import { GET, PUT, newFetch } from '../../../../../helpers/fetch';
import LayoutContext from '../../../../../store/Layout/contexts';
const { API_URL } = config;

const EditAdmin = ({ history, match: { params } }) => {
  const type = localStorage.getItem('type');
  const admin_id = params.admin_id;

  const [admin, setAdmin] = useState({});
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employeeNo, setEmployeeNo] = useState('');
  const [designation, setDesignation] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [isOps, setIsOps] = useState(false);
  const [isSuper, setIsSuper] = useState(false);
  const [isClientAdmin, setIsClientAdmin] = useState(false);
  const [clients, setClients] = useState('');
  const [selectedClients, setSelectedClients] = useState([]);
  const showSiteCheckboxes = Boolean(isOps) || isClientAdmin;

  const firstNameHandler = (e) => setFirstName(e.target.value);
  const lastNameHandler = (e) => setLastName(e.target.value);
  const employeeNoHandler = (e) => setEmployeeNo(e.target.value);
  const designationHandler = (e) => setDesignation(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const phoneNoHandler = (e) => setPhoneNo(e.target.value);

  const [validated, setValidated] = useState(false);

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?',
      )
    ) {
      setFirstName(admin.first_name);
      setLastName(admin.last_name);
      setEmployeeNo(admin.employee_no);
      setEmail(admin.email);
      setDesignation(admin.designation);
      setEmail(admin.email);
      setPhoneNo(admin.phone_no);
      const clientAdmin = admin.type === 'client';
      const superAdmin = !clientAdmin && Boolean(admin.is_super);
      setIsClientAdmin(clientAdmin);
      setIsSuper(superAdmin);
      setIsOps(!clientAdmin && !superAdmin && Boolean(admin.is_ops));
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    const data = {
      first_name: firstName,
      last_name: lastName,
      employee_no: employeeNo,
      designation,
      email,
      phone_no: phoneNo,
      is_ops: isOps,
      is_super: isSuper,
      type: isClientAdmin ? 'client' : 'admin',
    };

    let url = `${API_URL}/admin/admins/${admin_id}`;
    let token = localStorage.getItem('token');

    try {
      let response = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(data),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
      1;
      let responseData = await response.json();

      if (responseData.success) {
        // Second API call for selected client IDs
        url = `${API_URL}/admin/admins-client/update`;
        const clientData = {
          admin_id: admin_id, // Assume the created admin ID is returned
          clients: selectedClients.map((client) => ({
            ...client,
            sites: showSiteCheckboxes ? client.sites : [],
          })), // Use the 'clients' state directly
        };

        await fetch(url, {
          method: 'POST',
          body: JSON.stringify(clientData),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        ToastUtil.success(responseData.message);
        history.push(`/admins/${admin_id}`);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      ToastUtil.error(error);
    }
  };

  const deactivateAdminHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to deactivate this admin?',
      )
    ) {
      let api_path = `/admin/${id}/activation/deactivate`;
      let response = await newFetch(PUT, api_path);
      ToastUtil.success(response.message);
      response.success && history.push(`/admins`);
    }
  };

  const activateAdminHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to activate this admin?',
      )
    ) {
      let api_path = `/admin/${id}/activation/activate`;
      let response = await newFetch(PUT, api_path);
      ToastUtil.success(response.message);
      response.success && history.push(`/admins`);
    }
  };

  const fetchClients = async () => {
    let api_path = '/client/options';
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let filtered = response.data.filter((client) => client.active === true);
      setClients(filtered);
    }
  };

  const fetchSelectedClients = async () => {
    let url = `${API_URL}/admin/admins-client/${admin_id}`;
    let token = localStorage.getItem('token');

    let response = await fetch(url, {
      method: 'GET',
      withCredentials: true,
      mode: 'cors',
      headers: {
        Authorization: token,
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        setSelectedClients(data.data);
      }
    } else {
      console.error('Network response was not ok', response.statusText);
    }
  };

  const handleCheckboxChange = (e) => {
    const clientId = parseInt(e.target.id, 10);
    const isChecked = e.target.checked;
    const client = clients.find((item) => item.id === clientId);

    if (isChecked) {
      // Add new client object to match your database structure
      setSelectedClients((prev) => [
        ...prev,
        {
          client_id: clientId,
          sites: showSiteCheckboxes
            ? (client?.sites || []).map((site) => ({ site_id: site.id }))
            : [],
        },
      ]);
    } else {
      // Remove client by matching client_id
      setSelectedClients((prev) =>
        prev.filter((item) => item.client_id !== clientId),
      );
    }
  };

  const handleSiteCheckboxChange = (clientId, siteId, isChecked) => {
    setSelectedClients((prev) =>
      prev.map((client) => {
        if (client.client_id !== clientId) return client;

        const sites = client.sites || [];

        return {
          ...client,
          sites: isChecked
            ? [...sites, { site_id: siteId }]
            : sites.filter((site) => site.site_id !== siteId),
        };
      }),
    );
  };

  const updateSelectedClientSites = (includeSites) => {
    setSelectedClients((prev) =>
      prev.map((selectedClient) => {
        const client = clients.find(
          (item) => item.id === selectedClient.client_id,
        );

        return {
          ...selectedClient,
          sites: includeSites
            ? (client?.sites || []).map((site) => ({ site_id: site.id }))
            : [],
        };
      }),
    );
  };

  const handleIsOpsCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsOps(checked);
    if (checked) {
      setIsSuper(false);
      setIsClientAdmin(false);
    }
    updateSelectedClientSites(checked);
  };

  const handleIsSuperCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsSuper(checked);
    if (checked) {
      setIsOps(false);
      setIsClientAdmin(false);
    }
    updateSelectedClientSites(false);
  };

  const handleIsClientAdminCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsClientAdmin(checked);
    if (checked) {
      setIsOps(false);
      setIsSuper(false);
    }
    updateSelectedClientSites(checked);
  };

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        let url = `${API_URL}/admin/admins/${admin_id}`;
        let token = localStorage.getItem('token');

        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          let data = await response.json();
          let adminData = data.data;

          setAdmin(adminData);
          setFirstName(adminData.first_name);
          setLastName(adminData.last_name);
          setEmployeeNo(adminData.employee_no);
          setDesignation(adminData.designation);
          setEmail(adminData.email);
          setPhoneNo(adminData.phone_no);
          const clientAdmin = adminData.type === 'client';
          const superAdmin = !clientAdmin && Boolean(adminData.is_super);
          setIsClientAdmin(clientAdmin);
          setIsSuper(superAdmin);
          setIsOps(
            !clientAdmin && !superAdmin && Boolean(adminData.is_ops),
          );
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchAdmin();
    fetchClients();
    fetchSelectedClients();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to="/admins"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i> Admin Management
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Edit Admin</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              style={{
                marginTop: '1rem',
                paddingLeft: '3rem',
                paddingRight: '3rem',
              }}
            >
              <div className="d-flex border rounded">
                <div
                  style={{
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Admin Information</strong>
                  <p className="pt-2">View and edit admin information</p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>First Name*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="firstName"
                        value={firstName}
                        placeholder="First name"
                        onChange={(e) => firstNameHandler(e)}
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter first name.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Last Name*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        name="lastName"
                        value={lastName}
                        type="text"
                        placeholder="Last name"
                        onChange={(e) => lastNameHandler(e)}
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter last name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="12">
                      <Form.Label>
                        <strong>Employee No*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        name="employeeNo"
                        value={employeeNo}
                        type="text"
                        placeholder="Employee No"
                        onChange={(e) => employeeNoHandler(e)}
                        maxLength={12}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter employee no.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="12">
                      <Form.Label>
                        <strong>Designation</strong> (optional)
                      </Form.Label>
                      <Form.Control
                        value={designation || ''}
                        type="text"
                        placeholder="Designation"
                        onChange={(e) => designationHandler(e)}
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="12">
                      <Form.Label>
                        <strong>Email*</strong>
                      </Form.Label>
                      <Form.Control
                        value={email}
                        type="email"
                        placeholder="Email"
                        onChange={(e) => emailHandler(e)}
                        maxLength={100}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid email.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="12">
                      <Form.Label>
                        <strong>Phone No</strong>
                      </Form.Label>
                      <Form.Control
                        value={phoneNo || ''}
                        type="text"
                        placeholder="Phone Number"
                        onChange={(e) => phoneNoHandler(e)}
                        maxLength={20}
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="12">
                      <label
                        className="mt-2 mb-2"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          type="checkbox"
                          id="IsOps"
                          checked={isOps}
                          style={{
                            marginRight: '5px',
                            transform: 'scale(1.1)',
                          }}
                          className="me-2"
                          onChange={handleIsOpsCheckboxChange}
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <span>{'Is Ops Admin'}</span>
                        </div>
                      </label>
                    </Form.Group>
                  </Row>
                  {type && type === 'superadmin' && (
                    <Row>
                      <Form.Group as={Col} md="12">
                        <label
                          className="mt-2 mb-2"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <input
                            type="checkbox"
                            id="IsSuper"
                            checked={isSuper}
                            style={{
                              marginRight: '5px',
                              transform: 'scale(1.1)',
                            }}
                            className="me-2"
                            onChange={handleIsSuperCheckboxChange}
                          />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            <span>{'Is Super Admin'}</span>
                          </div>
                        </label>
                      </Form.Group>
                    </Row>
                  )}
                  <Row>
                    <Form.Group as={Col} md="12">
                      <label
                        className="mt-2 mb-2"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          type="checkbox"
                          id="IsClientAdmin"
                          checked={isClientAdmin}
                          style={{
                            marginRight: '5px',
                            transform: 'scale(1.1)',
                          }}
                          className="me-2"
                          onChange={handleIsClientAdminCheckboxChange}
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <span>{'Is Client Admin'}</span>
                        </div>
                      </label>
                    </Form.Group>
                  </Row>
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: '2rem',
                paddingLeft: '3rem',
                paddingRight: '3rem',
                paddingBottom: '6rem',
              }}
            >
              <div className="d-flex border rounded bg-white">
                <div
                  style={{
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Assign Client</strong>
                  <p className="pt-2">View and assign client to admin</p>
                </div>
                <div style={{ margin: '2rem' }}>
                  {clients &&
                    clients.length > 0 &&
                    clients.map((client) => {
                      const selectedClient = selectedClients.find(
                        (item) => item.client_id === client.id,
                      );
                      const isChecked = Boolean(selectedClient);

                      return (
                        <div key={client.id}>
                          <label
                            className="mb-2"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <input
                              type="checkbox"
                              id={client.id}
                              checked={isChecked}
                              style={{
                                marginRight: '5px',
                                transform: 'scale(1.1)',
                              }}
                              className="me-2"
                              onChange={handleCheckboxChange}
                            />
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <span>{client.name}</span>
                            </div>
                          </label>
                          {showSiteCheckboxes &&
                            isChecked &&
                            client.sites &&
                            client.sites.length > 0 && (
                              <div className="ms-4 mb-2">
                                {client.sites.map((site) => {
                                  const isSiteChecked = (
                                    selectedClient?.sites || []
                                  ).some(
                                    (selectedSite) =>
                                      selectedSite.site_id === site.id,
                                  );

                                  return (
                                    <label
                                      key={site.id}
                                      className="mb-2"
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`${client.id}-${site.id}`}
                                        checked={isSiteChecked}
                                        style={{
                                          marginRight: '5px',
                                          transform: 'scale(1.1)',
                                        }}
                                        className="me-2"
                                        onChange={(event) =>
                                          handleSiteCheckboxChange(
                                            client.id,
                                            site.id,
                                            event.target.checked,
                                          )
                                        }
                                      />
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                        }}
                                      >
                                        <span>{site.name}</span>
                                      </div>
                                    </label>
                                  );
                                })}
                              </div>
                            )}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex justify-content-between align-items-center"
            >
              <div className="d-flex">
                {admin.active ? (
                  <button
                    type="button"
                    onClick={() => deactivateAdminHandler(admin.id)}
                    className="btn btn-outline-danger align-items-start adjust-fs adjust-shadow mx-2"
                    style={{ width: '12rem' }}
                  >
                    Deactivate Admin
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => activateAdminHandler(admin.id)}
                    className="btn btn-outline-success align-items-start adjust-fs adjust-shadow mx-2"
                    style={{ width: '12rem' }}
                  >
                    Activate Admin
                  </button>
                )}

              </div>

              <div className="d-flex">
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={discardHandler}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default EditAdmin;
